import { useContext, useEffect } from "react";
import { OrbitProgress } from "react-loading-indicators";
import "../styles/LoadingComponent.css";
import { StateContext } from "../context/StateContext";
import { PanelContent } from "./ContentsStyled";
import labels from "../translation/index.json";

export default function LoadingComponent() {
  const appState = useContext(StateContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      appState.updateState({
        status: "request-complete",
        responseData: {
          serverResponse: { status: "error" },
          responseType: "activation",
          productType: "hehexd",
          generatedBy: "waaow",
        },
      });
    }, 12000);

    return () => clearTimeout(timer);
  }, [appState]);

  return (
    <PanelContent height="290px">
      <OrbitProgress color="#692198" size="small" text="" textColor="" />
      <p>{labels.contactLiceneServer}</p>
    </PanelContent>
  );
}
